document.addEventListener("DOMContentLoaded", () => {
	// Initialize product customization if element exists
	const customizeElement = document.querySelector("product-customize");
	if (customizeElement) {
		window.productCustomizer = new ProductCustomize(customizeElement);
	}
});

class ProductCustomize {
	constructor(element) {
		this.element = element;
		this.customizeSettings = customizeSettings || window.customizeSettings || {};
		this.productState = window.productState || {};
		this.selectedValues = {
			size: null,
			material: null,
			shape: null,
			stone: null,
			stoneType: null,
			side: [],
		};

		this.init();
	}

	init() {
		try {
			this.getElements();
			this.setStoneConfig();
			this.addEventListeners();
			this.handleCustomize();
		} catch (error) {
			console.warn("Error initializing product customize:", error);
		}
	}

	getElements() {
		// Option selection elements
		this.sizeEls = this.element.querySelectorAll(".js-product-size") || [];
		this.materialEls = this.element.querySelectorAll(".js-material") || [];
		this.shapeEls = this.element.querySelectorAll(".js-shape") || [];
		this.stoneEls = this.element.querySelectorAll(".js-stone") || [];
		this.sideWrapperEls =
			this.element.querySelectorAll(".js-side-wrapper") || [];

		// Preview elements
		this.previewContainer = document.querySelector(".js-preview-customize");
		this.previewMetalEls =
			document.querySelectorAll(".js-preview-metal") || [];
		this.previewStoneEls =
			document.querySelectorAll(".js-preview-stone") || [];
		this.previewSymbolEls =
			document.querySelectorAll(".js-preview-symbol") || [];
		this.previewInitialEls =
			document.querySelectorAll(".js-preview-initial") || [];
		this.previewMetalFaceEls =
			document.querySelectorAll(".js-preview-metal-face") || [];

		// Other elements
		this.productPrice = document.querySelector(".js-product-info-price");
		this.buttonAtcEl = this.element.querySelector(".js-button-atc");
		this.form =
			document.forms[this.element.getAttribute("form-id")] || null;

		// Get initial selected values
		this.getSelectedValues();
	}

	setStoneConfig() {     
		if (!this.customizeSettings || !this.previewMetalFaceEls.length) return;

		if (this.customizeSettings.stone_position) {
			const [top, left] =
				this.customizeSettings.stone_position.split(",");

			this.previewMetalFaceEls.forEach((el) => {
				if (el) {
					el.style.width = this.customizeSettings.stone_width || "";
					el.style.transform = this.customizeSettings.stone_rotation
						? `rotate(${this.customizeSettings.stone_rotation}deg)`
						: "";
					el.style.top = top || "";
					el.style.left = left || "";
				}
			});
		}
	}

	addEventListeners() {
		// Size selection
		this.sizeEls.forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				this.handleItemClick(this.sizeEls, e.target);
			});
		});

		// Material selection
		this.materialEls.forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				this.handleItemClick(this.materialEls, e.target);
			});
		});

		// Shape selection
		this.shapeEls.forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				this.handleItemClick(this.shapeEls, e.target);
			});
		});

		// Stone selection
		this.stoneEls.forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				this.handleItemClick(this.stoneEls, e.target);
			});
		});

		// Add to cart button
		if (this.buttonAtcEl) {
			this.buttonAtcEl.addEventListener("click", (e) => {
				e.preventDefault();
				//this.addToCart();
			});
		}

		// Setup side wrapper functionality
		this.setupSideWrapperListeners();

        this.previewMetalEls.forEach((element) => {
          if (element.getAttribute("data-side-type") !== "initial") {
            element.classList.remove("hidden");
            element.classList.remove("!hidden");
          } else {
            element.classList.add("hidden");
            element.classList.add("!hidden");
          }
        });
	}

	setupSideWrapperListeners() {
		if (!this.sideWrapperEls || !this.sideWrapperEls.length) return;

		this.sideWrapperEls.forEach((wrapper, index) => {
			// Side toggle buttons (symbol/initial)
			const toggleBtns =
				wrapper.querySelectorAll(".js-side-toggle") || [];
			const currentSide = wrapper.getAttribute("data-side") || "";
			const previewFace = document.querySelector(
				`.js-preview-metal-face[data-side="${index + 1}"]`
			);

			toggleBtns.forEach((btn) => {
				btn.addEventListener("click", (e) => {
					e.preventDefault();
					const sideType = btn.getAttribute("data-value") || ""; // 'symbol' or 'initial'

					// Update toggle buttons UI
					toggleBtns.forEach((b) =>
						b.removeAttribute("aria-current")
					);
					btn.setAttribute("aria-current", "true");
                    
					if(document.getElementById('pdt_custom_first_image').value == 'Product media')
                    	productSwiper.slideTo(index + 1);
					else
						productSwiper.slideTo(index);

					// Update wrapper data attribute
					wrapper.setAttribute("data-side", sideType);

                    document.querySelector(`.js-preview-metal-face[data-side="${index}"]`).setAttribute("data-type", sideType);

					let value = "";
					if (sideType === "symbol") {
						const activeSymbol = wrapper.querySelector(
							".js-side-symbol.active"
						);
						value = activeSymbol
							? activeSymbol.getAttribute("data-name") || ""
							: "";
					} else {
						const initialInput =
							wrapper.querySelector(".js-side-initial");
						value = initialInput
							? initialInput.value.toUpperCase()
							: "LF";
					}

					wrapper.setAttribute("data-value", value);

					// Update displayed value
					const valueDisplay =
						wrapper.querySelector(".js-selected-value");
					if (valueDisplay) valueDisplay.textContent = value;

					this.handleCustomize();
				});
			});

			// Symbol selection buttons
			const symbolBtns =
				wrapper.querySelectorAll(".js-side-symbol") || [];
			symbolBtns.forEach((btn) => {
				btn.addEventListener("click", (e) => {
					e.preventDefault();

					// Remove active class from all symbols
					symbolBtns.forEach((b) => b.classList.remove("active"));

					if(document.getElementById('pdt_custom_first_image').value == 'Product media')
                  		productSwiper.slideTo(e.target.getAttribute('data-slide') + 1);
					else
						productSwiper.slideTo(e.target.getAttribute('data-slide'));

					// Add active class to clicked symbol
					btn.classList.add("active");

					const value = btn.getAttribute("data-name") || "";
					const image = btn.getAttribute("data-image") || "";

					// Update wrapper attributes
					wrapper.setAttribute("data-value", value);
					wrapper.setAttribute("data-image", image);

					// Update displayed value
					const valueDisplay =
						wrapper.querySelector(".js-selected-value");
					if (valueDisplay) valueDisplay.textContent = value;

					this.handleCustomize();
				});
			});

			// Initial input field
			const initialInput = wrapper.querySelector(".js-side-initial");
			if (initialInput) {
				// Allow only letters and space
				initialInput.addEventListener("keypress", (e) => {
					const char = String.fromCharCode(e.which);
					if (!/[A-Za-z\s]/.test(char)) {
						e.preventDefault();
					}
				});

				// Handle input changes
				initialInput.addEventListener("input", (e) => {
					const value = e.target.value.toUpperCase();

					// Update wrapper attribute
					wrapper.setAttribute("data-value", value);

					if(document.getElementById('pdt_custom_first_image').value == 'Product media')
                  		productSwiper.slideTo(e.target.getAttribute('data-slide') + 1);
					else
						productSwiper.slideTo(e.target.getAttribute('data-slide'));

					// Update displayed value
					const valueDisplay =
						wrapper.querySelector(".js-selected-value");
					if (valueDisplay) valueDisplay.textContent = value;

					this.handleCustomize();
				});
			}
		});
	}

	handleItemClick(elements, clickedEl) {
		try {
			// Remove active class from all elements
			elements.forEach((el) => el.classList.remove("active"));

			// Add active class to clicked element
			clickedEl.classList.add("active");

			// Update label with selected value
			const name =
				clickedEl.getAttribute("data-name") ||
				clickedEl.textContent.trim() ||
				"";
			const valueLabel = clickedEl
				.closest("div")
				?.parentNode?.querySelector(".js-selected-value");

			if (valueLabel) {
				valueLabel.textContent = name;
			}

			if(document.getElementById('pdt_custom_first_image').value == 'Product media' && productSwiper.activeIndex == 0)
				productSwiper.slideTo(1);

			this.handleCustomize();
		} catch (error) {
			console.warn("Error handling item click:", error);
		}
	}

	handleCustomize() {
		try {
			this.getSelectedValues();
			this.getCurrentVariant();
			this.updateProductDisplay();
			this.updateImagePreview();
		} catch (error) {
			console.warn("Error in handleCustomize:", error);
		}
	}

	getSelectedValues() {
		const activeSize = this.element.querySelector(
			".js-product-size.active"
		);
		const activeMaterial = this.element.querySelector(
			".js-material.active"
		);
		const activeShape = this.element.querySelector(".js-shape.active");
		const activeStone = this.element.querySelector(".js-stone.active");

		this.selectedValues = {
			size: activeSize ? activeSize.textContent.trim() : null,
			material: activeMaterial
				? activeMaterial.getAttribute("data-name")
				: null,
			shape: activeShape ? activeShape.getAttribute("data-name") : null,
			stone: activeStone ? activeStone.getAttribute("data-name") : null,
			stoneType: activeStone
				? activeStone.getAttribute("data-type")
				: null,
			side: [],
		};

		// Get side customization values
		if (this.sideWrapperEls) {
			this.sideWrapperEls.forEach((wrapper, index) => {
				if (wrapper) {
					const side = {
						type: wrapper.getAttribute("data-side") || "",
						value: wrapper.getAttribute("data-value") || "",
						image: wrapper.getAttribute("data-image") || null,
					};

					this.selectedValues.side[index] = side;
				}
			});
		}
	}

	getCurrentVariant() {
		if (!this.customizeSettings?.variants) {
			this.currentVariant = null;
			return;
		}

		if (this.customizeSettings.variants.length === 1) {
			this.currentVariant = this.customizeSettings.variants[0];
			return;
		}

		// This line attempts to find a variant within the 'this.customizeSettings.variants' array.
        this.currentVariant = this.customizeSettings.variants.find((variant) => {
          // For each 'variant' in the array, we check its 'options' to see if it matches
          // the currently selected values (size, material, stoneType).
        
          // We first check the number of options this variant has.
          if (variant.options.length === 1) {
            // If the variant has only one option, we check if that option includes
            // any of the currently selected values (size, material, or stoneType).
            return (
              variant.options.includes(this.selectedValues.size) ||
              variant.options.includes(this.selectedValues.material) ||
              variant.options.includes(this.selectedValues.stoneType)
            );
          } else if (variant.options.length === 2) {
            // If the variant has exactly two options, we check if its options include
            // both the selected 'material' AND the selected 'stoneType'.
            return (
              variant.options.includes(this.selectedValues.material) &&
              variant.options.includes(this.selectedValues.stoneType)
            );
          } else {            
            // If the variant has more than two options (or exactly three, based on the original code's logic),
            // we check if its options include the selected 'size', 'material', AND 'stoneType'.
            return (
              variant.options.includes(this.selectedValues.size) &&
              variant.options.includes(this.selectedValues.material) &&
              (this.selectedValues.stoneType !== null
              ? variant.options.includes(this.selectedValues.stoneType)
              : variant.options.includes(this.selectedValues.shape))
            );
          }
        });

		// Default to first variant if no match found
		if (
			!this.currentVariant &&
			this.customizeSettings.variants.length > 0
		) {
			this.currentVariant = this.customizeSettings.variants[0];
		}
	}

    formatMoney(cents, format) {
        if (typeof cents == 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /{{\s*(\w+)\s*}}/;
        var formatString = (format || Shopify.money_format);
        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');
            if (isNaN(number) || number == null) {
                return 0;
            }
            number = (number / 100.0).toFixed(precision);
            var parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';
            return dollars + cents;
        }
    
        value = cents.toLocaleString('en-US') + " ";
          
        return formatString.replace(placeholderRegex, value);
    };

	updateProductDisplay() {
		if (!this.currentVariant) return;
      
		// Update price display
		if (this.productPrice) {
			try {				
				let priceHtml = `<span class="h6">
                  ${this.formatMoney(this.currentVariant.price / 100)}
                </span>`;

				if (
					this.currentVariant.compare_at_price >
					this.currentVariant.price
				) {
					priceHtml += `<s class="h6">
                        ${this.formatMoney(
							this.currentVariant.compare_at_price / 100
						)}
                      </s>`;
				}

				this.productPrice.innerHTML = priceHtml;
			} catch (error) {
				console.warn("Error updating product price:", error);
			}
		}

		// Update add to cart button state
		if (this.buttonAtcEl && this.currentVariant) {
			this.buttonAtcEl.disabled = !this.currentVariant.available;
		}
	}

	updateImagePreview() {
		try {
			const { material, shape, stone, side } = this.selectedValues;
            const materialFirstName = material.split(" ").slice(1).join(" ");
          
			if (!materialFirstName && !shape && !stone && !this.customizeSettings) {
				return;
			}

			// Find metal image
			let metalImage;
			const metalList = this.customizeSettings.metal || [];
			const matchingMetal = metalList.find(
				(item) =>
					item &&
					(item.metal_type === material || item.metal_type.includes(materialFirstName)) &&
					item.stone_shape === shape
			);

			if (matchingMetal) {
				metalImage = matchingMetal.image;
			}
          
			// Find stone image
			const stoneImage = this.customizeSettings.stone.find(stoneSetting =>
              (stoneSetting.metal_type.includes(material) || stoneSetting.metal_type.find(metal => metal.includes(materialFirstName))) &&
              stoneSetting.stone_shape.includes(shape) &&
              stoneSetting.stone_type === stone
            )?.image;

			// Update metal and stone previews
			this.updatePreviewElements(this.previewMetalEls, metalImage);
			this.updatePreviewElements(this.previewStoneEls, stoneImage);

			// Update side customizations
			if (side && side.length) {
				side.forEach((sideData, index) => {
					if (!sideData) return;

					if (sideData.type === "symbol") {
						// Update symbol preview
						const symbolPreview = this.previewSymbolEls[index];
						if (symbolPreview && sideData.image) {
							symbolPreview.setAttribute("src", `https:${sideData.image}`);
							symbolPreview.style.display = "";
						}

						// Hide initial preview for this side
						const initialPreview = this.previewInitialEls[index];
						if (initialPreview) {
							initialPreview.style.display = "none";
						}
					} else {
						// Handle initial preview using sprite technique
						const initialValue = sideData.value || "";
						const initialPreview = this.previewInitialEls[index];
						const symbolPreview = this.previewSymbolEls[index];

						if (symbolPreview) symbolPreview.style.display = "none";

						if (initialPreview) {
							initialPreview.style.display = "";

							// Clear previous content
							initialPreview.innerHTML = "";

							// Create character spans
							const letters = initialValue.split("");
							letters.forEach((char) => {
								if (char === " ") return;

								const span = document.createElement("span");
								span.setAttribute("data-char", char);
								initialPreview.appendChild(span);
							});
						}
					}
				});
			}
		} catch (error) {
			console.warn("Error updating image preview:", error);
		}
	}

	updatePreviewElements(elements, imageUrl) {
		if (!elements || !elements.length) return;

		elements.forEach((el) => {
			if (!el) return;

			if (imageUrl) {
				if (el.tagName === "IMG") {
					el.src = imageUrl.startsWith("http")
						? imageUrl
						: `https:${imageUrl}`;
					el.style.display = "";
				} else {
					el.style.backgroundImage = `url('${
						imageUrl.startsWith("http")
							? imageUrl
							: `https:${imageUrl}`
					}')`;
					el.style.display = "";
				}
			} else {
				el.style.display = "none";
			}
		});
	}

    //NOT USED//////////// used the one in theme.js
	async addToCart() {
		if (!this.currentVariant?.id) return;

        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

		// Show loading state
		if (this.buttonAtcEl) {
            this.buttonAtcEl.setAttribute("aria-busy", "true");
    		this.buttonAtcEl.classList.add("loading");
		}

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      
		const properties = {
			Metal: this.selectedValues.material || "",
			Shape: this.selectedValues.shape || "",
			Stone: this.selectedValues.stone || "",
            sections: sectionsToBundle.join(","),
		};

		// Add side customizations to properties
		if (this.selectedValues.side[0]) {
			properties[
				`${
					this.selectedValues.side[0].type === "symbol"
						? "Symbol"
						: "Initial"
				} Side 1`
			] = this.selectedValues.side[0].value;
		}

		if (this.selectedValues.side[1]) {
			properties[
				`${
					this.selectedValues.side[1].type === "symbol"
						? "Symbol"
						: "Initial"
				} Side 2`
			] = this.selectedValues.side[1].value;
		}

		try {
			// Add to cart
			const response = await fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					items: [
						{
							id: this.currentVariant.id,
							quantity: 1,
							properties: properties,
						},
					],
				}),
			});

            const responseJson = await response.json();
          
            document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));

			if (response.ok) {
              if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
                return window.location.href = `${Shopify.routes.root}cart`;
              }
              const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
              cartContent["sections"] = responseJson["sections"];
              const items = responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson];
             
              document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                  baseEvent: "variant:add",
                  cart: cartContent
                }
              }));
              if (window.themeVariables.settings.cartType === "message") {
                document.dispatchEvent(new CustomEvent("toast:show", {
                  detail: {
                    message: window.themeVariables.strings.addedToCart.replace("{{product_title}}", items?.[0]?.title)
                  }
                }));
              }
            } else {
				document.dispatchEvent(new CustomEvent("toast:show", {
                detail: {
                  message: responseJson["message"],
                  tone: "error"
                }
              }));
              document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
			}

			// Handle successful cart addition
			/*try {
				const cartData = await (await fetch("/cart?view=ajax")).json();

				// Try to dispatch events, but don't fail if something goes wrong
				try {
					if (window.globalEmitter && window.emitterProps) {
						window.globalEmitter.emit(
							window.emitterProps.cart.add,
							cartData
						);
						window.globalEmitter.emit(
							window.emitterProps.cart.change,
							cartData.item_count
						);
					}
				} catch (eventError) {
					console.warn("Error dispatching events:", eventError);
				}

				document.dispatchEvent(
					new CustomEvent("cart:add", {
						detail: cartData,
					})
				);

				document.dispatchEvent(
					new CustomEvent("cart:change", {
						detail: cartData.item_count,
					})
				);
			} catch (cartFetchError) {
				console.warn("Error fetching cart data:", cartFetchError);
				// Dispatch basic event anyway with limited info
				document.dispatchEvent(new CustomEvent("cart:change"));
			}*/
		} catch (error) {
			console.error("Error adding to cart:", error);

			// Show error message if available
			try {
				if (window.globalEmitter && window.emitterProps) {
					window.globalEmitter.emit(
						window.emitterProps.notice.global,
						{
							type: "error",
							content:
								error.message ||
								"Could not add to cart. Please try again.",
						}
					);
				}
			} catch (noticeError) {
				console.warn("Error showing notice:", noticeError);
			}
		} finally {
			// Remove loading state
			if (this.buttonAtcEl) {
                this.buttonAtcEl.removeAttribute("aria-busy");
				this.buttonAtcEl.classList.remove("loading");
			}
		}
	}
}
